import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom'
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
// import GeographyDashboardContainer from './Components/GeographyDashboard/GeographyDashboardContainer'
// import sampleData from './data/dataviz-survey-results-sample.json';
// import datavizData19 from './data/dataviz-survey-results.json';

//import dashboardData from './data/dashboard_data.json';

//const containerData = dashboardData[9]

ReactDOM.render(<Router>
                   {/* <GeographyDashboardContainer/>    */}
                 <App />
                 </Router>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
